import * as Yup from 'yup';
import { InterviewMode, InterviewType, TEXTAREA_LIMIT } from '../constants/common';
import { resumeValidation } from '../utils/common';

export const addEditInterviewSchema = Yup.object({
  isEdit: Yup.boolean(),
  candidateID: Yup.string().when('isEdit', {
    is: true,
    then: Yup.string().required('Candidate is required.')
  }),
  interviewType: Yup.string().when('isEdit', {
    is: true,
    then: Yup.string().required('Interview Type is required.')
  }),
  interviewRoundMode: Yup.string().when('isEdit', {
    is: true,
    then: Yup.string()
  }),
  // interviewerID: Yup.array().when(['isEdit'], {
  //   is: (isEdit) => isEdit,
  //   then: Yup.array().min(1, 'Interviewer is required.').required('Interviewer is required.')
  // }),
  interviewerID: Yup.array().when(['isEdit', 'interviewerLimit'], {
    is: (isEdit, interviewerLimit) => isEdit === true && !!interviewerLimit,
    then: Yup.array()
      .test(
        'exact-interviewer-limit',
        'Number of selected interviewers must exactly match the interviewer limit.',
        function (value) {
          const { interviewerLimit } = this.parent;

          if (!Array.isArray(value)) return false;

          return value.length === Number(interviewerLimit);
        }
      )
      .required('Interviewer is required.'),
    otherwise: Yup.array().notRequired()
  }),
  feedbackParameterIds: Yup.array().when(['isEdit', 'interviewType'], {
    is: (isEdit, interviewType) =>
      isEdit &&
      (interviewType === InterviewType['Technical Interview - 1'].toString() ||
        interviewType === InterviewType['Technical Interview - 2'].toString() ||
        interviewType === InterviewType['Management Round'].toString()),
    then: Yup.array()
      .min(1, 'Feedback Parameter is required.')
      .required('Feedback Parameter is required.')
  }),
  interviewCategory: Yup.string(),
  jobId: Yup.string().when('isEdit', {
    is: true,
    then: Yup.string().required('Job Role is required.')
  }),
  duration: Yup.number().when('isEdit', {
    is: true,
    then: Yup.number().typeError('Interview duration is required.')
  }),
  meetingLink: Yup.string()
    .trim()
    .when('interviewRoundMode', {
      is: (mode) => {
        return Number(mode) === InterviewMode.Online;
      },
      then: Yup.string()
        .required('Meeting link is required for online interview')
        .url('Please enter a valid meeting link'),
      otherwise: Yup.string().nullable()
    }),
  interviewerLimit: Yup.number().when(['isEdit'], {
    is: (isEdit) => isEdit,
    then: Yup.number()
      .min(1, 'Minimum Limit 1')
      .max(10, 'Maximum  Limit 10')
      .typeError('Only numbers are allowed.')
      .required('Interviewer Limit is required.')
  }),
  jobDesignation: Yup.string().nullable(),
  description: Yup.string()
    .trim()
    .max(TEXTAREA_LIMIT.MAX, 'Designation should not exceed ${max} characters.')
    .nullable(),
  resumeFilePath: Yup.mixed().test(
    'format',
    'Only the following formats are accepted: .doc, .docx, .pdf',
    (value) => {
      if (!value) {
        return true;
      }
      return resumeValidation(value);
    }
  )
});

export const addEditInterviewRoundSchema = Yup.object({
  isRescheduleEnabled: Yup.boolean(),
  isHrRound: Yup.boolean(),
  interviewType: Yup.string().trim().required('Interview Type is required.'),
  jobId: Yup.string().trim().required('Job Role is required.'),
  interviewRoundMode: Yup.string().trim().typeError('Please select interview round mode'),
  interviewerID: Yup.array()
    .test(
      'exact-interviewer-limit',
      'Number of selected interviewers must exactly match the interviewer limit.',
      function (value) {
        const { interviewerLimit } = this.parent;
        return value?.length === Number(interviewerLimit);
      }
    )
    .required('Please select interviewers.'),
  feedbackParameterIds: Yup.array().when('interviewType', {
    is: (interviewType) =>
      interviewType === InterviewType.Practical.toString() ||
      interviewType === InterviewType['HR Round'].toString(),
    then: Yup.array(),
    otherwise: Yup.array()
      .min(1, 'Feedback Parameter is required.')
      .required('Feedback Parameter is required.')
  }),
  duration: Yup.number().typeError('Interview duration is required.'),
  interviewerLimit: Yup.number()
    .min(1, 'Minimum Limit 1')
    .max(10, 'Maximum  Limit 10')
    .typeError('Only numbers are allowed.')
    .required('Interviewer Limit is required.'),
  meetingLink: Yup.string()
    .trim()
    .when('interviewRoundMode', {
      is: (mode) => {
        return Number(mode) === InterviewMode.Online;
      },
      then: Yup.string()
        .required('Meeting link is required for online interview')
        .url('Please enter a valid meeting link'),
      otherwise: Yup.string().nullable()
    }),
  description: Yup.string()
    .trim()
    .min(TEXTAREA_LIMIT.MIN, 'Description should be at least ${min} characters.')
    .max(TEXTAREA_LIMIT.MAX, 'Description should not exceed ${max} characters.')
    .nullable()
});
